module.exports = __webpack_public_path__ + "img/crossroad.f33fa6be.svg";